import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UsersRoutingModule} from './users-routing.module';
import {ProductOrdersComponent} from './product-orders/product-orders.component';
import {PackageOrdersComponent} from './package-orders/package-orders.component';
import {ReactiveFormsModule} from '@angular/forms';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {CoreCommonModule} from '../../../@core/common.module';
import {SharedModule} from '../../shared/shared.module';

@NgModule({
    declarations: [ProductOrdersComponent, PackageOrdersComponent],
    imports: [
        CommonModule,
        UsersRoutingModule,
        ReactiveFormsModule,
        NgbPaginationModule,
        CoreCommonModule,
        SharedModule
    ]
})
export class UsersModule {
}
